import React from 'react'
import './LoadingBlocker.css'
import loader from '../../assets/loader.gif'

export default () => {
  return <div className='frags-loading-blocker-wrapper'>
    <img src={loader}/>
  </div>
}


// WEBPACK FOOTER //
// app/javascript/components/frags/LoadingBlocker/LoadingBlocker.js